/*=============================================== Grid ===============================================*/
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*==================== Imports ====================*/
import React from "react";
import styled, { css } from "styled-components";
import { stringifyPx } from "js-utils-julseb";
import Variables from "./Variables";
/*==================== Component ====================*/
var Grid = function (_a) {
    var inline = _a.inline, col = _a.col, gap = _a.gap, columnGap = _a.columnGap, rowGap = _a.rowGap, justifyItems = _a.justifyItems, alignItems = _a.alignItems, justifyContent = _a.justifyContent, alignContent = _a.alignContent, padding = _a.padding, colTablet = _a.colTablet, colMobile = _a.colMobile, children = _a.children, props = __rest(_a, ["inline", "col", "gap", "columnGap", "rowGap", "justifyItems", "alignItems", "justifyContent", "alignContent", "padding", "colTablet", "colMobile", "children"]);
    return (React.createElement(Container, __assign({ "$inline": inline, "$col": col, "$gap": gap, "$columnGap": columnGap, "$rowGap": rowGap, "$justifyItems": justifyItems, "$alignItems": alignItems, "$justifyContent": justifyContent, "$alignContent": alignContent, "$padding": padding, "$colTablet": colTablet, "$colMobile": colMobile }, props), children));
};
export default Grid;
/*==================== Types ====================*/
var col = {
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9,
    10: 10,
    11: 11,
    12: 12,
};
/*==================== Styles ====================*/
var Container = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: ", ";\n    grid-template-columns: ", ";\n    gap: ", ";\n    column-gap: ", ";\n    row-gap: ", ";\n    justify-items: ", ";\n    align-items: ", ";\n    justify-content: ", ";\n    align-content: ", ";\n    padding: ", ";\n\n    @media ", " {\n        grid-template-columns: ", ";\n    }\n\n    @media ", " {\n        grid-template-columns: ", ";\n    }\n\n    ", "\n"], ["\n    display: ", ";\n    grid-template-columns: ", ";\n    gap: ", ";\n    column-gap: ", ";\n    row-gap: ", ";\n    justify-items: ", ";\n    align-items: ", ";\n    justify-content: ", ";\n    align-content: ", ";\n    padding: ", ";\n\n    @media ", " {\n        grid-template-columns: ", ";\n    }\n\n    @media ", " {\n        grid-template-columns: ", ";\n    }\n\n    ", "\n"])), function (_a) {
    var $inline = _a.$inline;
    return ($inline ? "inline-grid" : "grid");
}, function (_a) {
    var $col = _a.$col;
    return (typeof $col === "number" ? "repeat(".concat($col, ", 1fr)") : $col);
}, function (_a) {
    var $gap = _a.$gap;
    return $gap === "xxl"
        ? Variables.Spacers.XXL
        : $gap === "xl"
            ? Variables.Spacers.XL
            : $gap === "l"
                ? Variables.Spacers.L
                : $gap === "m"
                    ? Variables.Spacers.M
                    : $gap === "s"
                        ? Variables.Spacers.S
                        : $gap === "xs"
                            ? Variables.Spacers.XS
                            : $gap === "xxs"
                                ? Variables.Spacers.XXS
                                : $gap
                                    ? stringifyPx($gap)
                                    : "";
}, function (_a) {
    var $columnGap = _a.$columnGap;
    return $columnGap === "xxl"
        ? Variables.Spacers.XXL
        : $columnGap === "xl"
            ? Variables.Spacers.XL
            : $columnGap === "l"
                ? Variables.Spacers.L
                : $columnGap === "m"
                    ? Variables.Spacers.M
                    : $columnGap === "s"
                        ? Variables.Spacers.S
                        : $columnGap === "xs"
                            ? Variables.Spacers.XS
                            : $columnGap === "xxs"
                                ? Variables.Spacers.XXS
                                : $columnGap
                                    ? stringifyPx($columnGap)
                                    : "";
}, function (_a) {
    var $rowGap = _a.$rowGap;
    return $rowGap === "xxl"
        ? Variables.Spacers.XXL
        : $rowGap === "xl"
            ? Variables.Spacers.XL
            : $rowGap === "l"
                ? Variables.Spacers.L
                : $rowGap === "m"
                    ? Variables.Spacers.M
                    : $rowGap === "s"
                        ? Variables.Spacers.S
                        : $rowGap === "xs"
                            ? Variables.Spacers.XS
                            : $rowGap === "xxs"
                                ? Variables.Spacers.XXS
                                : $rowGap
                                    ? stringifyPx($rowGap)
                                    : "";
}, function (_a) {
    var $justifyItems = _a.$justifyItems;
    return $justifyItems;
}, function (_a) {
    var $alignItems = _a.$alignItems;
    return $alignItems;
}, function (_a) {
    var $justifyContent = _a.$justifyContent;
    return $justifyContent;
}, function (_a) {
    var $alignContent = _a.$alignContent;
    return $alignContent;
}, function (_a) {
    var $padding = _a.$padding;
    return $padding === "xxl"
        ? Variables.Spacers.XXL
        : $padding === "xl"
            ? Variables.Spacers.XL
            : $padding === "l"
                ? Variables.Spacers.L
                : $padding === "m"
                    ? Variables.Spacers.M
                    : $padding === "s"
                        ? Variables.Spacers.S
                        : $padding === "xs"
                            ? Variables.Spacers.XS
                            : $padding === "xxs"
                                ? Variables.Spacers.XXS
                                : $padding
                                    ? stringifyPx($padding)
                                    : "";
}, Variables.Breakpoints.Tablet, function (_a) {
    var $col = _a.$col;
    return $col && $col >= 6 ? "repeat(4, 1fr)" : $col === 4 || $col === 5 ? "repeat(3, 1fr)" : "repeat(2, 1fr)";
}, Variables.Breakpoints.Mobile, function (_a) {
    var $col = _a.$col;
    return ($col && $col >= 6 ? "repeat(2, 1fr)" : "repeat(1, 1fr)");
}, function (_a) {
    var $col = _a.$col, $colTablet = _a.$colTablet, $colMobile = _a.$colMobile;
    return typeof $col === "number"
        ? css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n                  @media ", " {\n                      grid-template-columns: repeat(\n                          ", ",\n                          1fr\n                      );\n                  }\n\n                  @media ", " {\n                      grid-template-columns: repeat(", ", 1fr);\n                  }\n              "], ["\n                  @media ", " {\n                      grid-template-columns: repeat(\n                          ", ",\n                          1fr\n                      );\n                  }\n\n                  @media ", " {\n                      grid-template-columns: repeat(", ", 1fr);\n                  }\n              "])), Variables.Breakpoints.Tablet, !$col
            ? 1
            : $col >= 6
                ? 4
                : $col === 4 || $col === 5
                    ? 3
                    : $col === 3 || $col === 2
                        ? 2
                        : 1, Variables.Breakpoints.Mobile, !$col ? 1 : $col >= 6 ? 2 : 1) : css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n                  @media ", " {\n                      grid-template-columns: ", ";\n                  }\n\n                  @media ", " {\n                      grid-template-columns: ", ";\n                  }\n              "], ["\n                  @media ", " {\n                      grid-template-columns: ", ";\n                  }\n\n                  @media ", " {\n                      grid-template-columns: ", ";\n                  }\n              "])), Variables.Breakpoints.Tablet, $colTablet, Variables.Breakpoints.Mobile, $colMobile);
});
var templateObject_1, templateObject_2, templateObject_3;
